import { Container } from '@mui/material';
import { PropsWithChildren, useCallback, useRef, useState } from 'react';
import { NavigationDrawer } from 'shared/components';
import { Header } from 'shared/header';
import { useWindowResize } from 'shared/hooks';
import { ProvideOnScreenText } from 'shared/providers/provideOnScreenText';

export function AuthLayout({ children }: PropsWithChildren<{}>) {
    const headerRef = useRef<HTMLDivElement | null>(null);

    const getHeaderHeight = useCallback(() => {
        const newValue = headerRef.current?.clientHeight || 0;
        setDrawerTopMargin(newValue);
    }, []);

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [drawerTopMargin, setDrawerTopMargin] = useState(0);
    useWindowResize(getHeaderHeight);

    const drawerOnCloseHandler = () => setIsDrawerOpen(false);
    const drawerToggleHandler = () => setIsDrawerOpen((prevState) => !prevState);

    return (
        <ProvideOnScreenText>
            <Header drawerToggleHandler={drawerToggleHandler} headerRef={headerRef} />
            <Container sx={{ mt: 3.5 }} maxWidth={false}>
                {children}
                <NavigationDrawer
                    drawerOnCloseHandler={drawerOnCloseHandler}
                    isDrawerOpen={isDrawerOpen}
                    drawerTopMargin={drawerTopMargin}
                />
            </Container>
        </ProvideOnScreenText>
    );
}
